export const STOCK_UNIT_TYPES = {
  permanent: 'Stała',
  disposable: 'Tymczasowa',
  undefined: '---'
}
